import { render, staticRenderFns } from "./UpdateStaffGroupPopUp.vue?vue&type=template&id=2f7ba5b7&scoped=true"
import script from "./UpdateStaffGroupPopUp.vue?vue&type=script&lang=js"
export * from "./UpdateStaffGroupPopUp.vue?vue&type=script&lang=js"
import style0 from "./UpdateStaffGroupPopUp.vue?vue&type=style&index=0&id=2f7ba5b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7ba5b7",
  null
  
)

export default component.exports